import { Component, OnInit } from '@angular/core';
import { CuotasService } from '../cuotas.service';
import {
  hideSpinner,
  showSpinner,
} from 'src/app/core/services/functions.service';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { FormControl } from '@angular/forms';
import { CokyTableColumn } from 'src/app/modules/shared/imports/components/table/table.component';

@Component({
  selector: 'app-cuotas',
  templateUrl: './cuotas.component.html',
  styleUrls: ['./cuotas.component.scss'],
})
export class CuotasComponent implements OnInit {
  rem: string = '';
  data: any;
  tableData: any;
  cuotaData: any;
  simData: any;
  plan: string = '';
  cuotasSim = new FormControl();
  columnasTituloTabla: CokyTableColumn[] = [
    { name: "cuotas", title: "Cuotas" },
    { name: "cuota_pagar", title: "Cuota a pagar" },
    { name: "capital_simular", title: "Capital a simular" },
    { name: "total_interes", title: "Total interés" },
    { name: "total_seguro", title: "Total seguro" },
    { name: "tarifa_seguro", title: "Tarifa seguro" },
    { name: "tea", title: "Tasa efectiva anual" }
  ]
  displayedColumns: string[] = ['cuotas', 'cuota_pagar'];
  selectedPlan: string;
  selectedCuota: string;
  constructor(
    private cuotaService: CuotasService,
    private helpers: HelpersService
  ) { }

  ngOnInit(): void { }

  consultar = async (rem) => {
    this.data = null;
    this.tableData = null;
    this.cuotaData = [];
    if (this.rem == '') return;
    showSpinner();
    let result: any = await this.cuotaService.consultar(rem);
    if (!result) {
      this.helpers.notifications.errorDialog('ORDEN DE PEDIDO NO ENCONTRADA', 'No se pudo encontrar la orden de pedido, intente nuevamente.');
      hideSpinner();
    } else {
      if (result.resultDatosRem.data.est != 'A') {
        this.helpers.notifications.errorDialog('CAMBIO DE PLAN NO PERMITIDO', 'Solo es posible realizar cambios de plan para Ops asentadas.');
        hideSpinner();
      } else {
        this.data = result.resultDatosRem.data;
        this.tableData = result.resultDatosCuotas.data;
        for (let i in this.data.cuotas) {
          for (let j in this.tableData) {
            if ((this.data.cuotas[i].ncuo_max == this.tableData[j].cuotas) && (this.data.cuotas[i].ncuo_max != this.data.plan)) {
              this.cuotaData.push({ cuotas: this.data.cuotas[i].ncuo_max, cuota_pagar: this.tableData[j].cuota_pagar })
            }
          }
        }
        const format = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        });
        this.data.vtacontado = format.format(this.data.vtacontado);
        this.data.cuo_ini = format.format(this.data.cuo_ini);
        this.data.capital_pasesaldo = format.format(this.data.capital_pasesaldo);
        this.data.capital = format.format(this.data.capital);
        this.data.valor = format.format(this.data.valor);
        this.plan = this.data.cuotas[0].ncuo_max;
        hideSpinner();
      }
    }

  };

  cambiar = async (plan, rem) => {
    if (this.rem == '' || this.plan == '') return;
    showSpinner();
    let result: any = await this.cuotaService.cambiar(plan, rem, this.data.n_ide);
    console.log(result);
    hideSpinner();
    if (result.success) {
      await this.helpers.notifications.successMessage('PLAN CAMBIADO CORRECTAMENTE');
      this.consultar(this.rem);
    } else {
      this.helpers.notifications.errorDialog('CAMBIAR PLAN', result.message);
    }
  };

  selectPlan(selected: any) {
    this.plan = selected.cuotas;
    this.selectedPlan = selected.cuotas;
    this.selectedCuota = selected.cuota_pagar;
  }

}
